const DRAG_HINT_EVENT = 'innex-drag-hint';

let current: string | null = null;

/** Show or clear the label that follows a dragged file or folder. */
export function setDragHint(label: string | null) {
  if (label === current) return;
  current = label;
  window.dispatchEvent(new CustomEvent(DRAG_HINT_EVENT, { detail: label }));
}

export function subscribeDragHint(onChange: (label: string | null) => void) {
  const handler = (event: Event) => onChange((event as CustomEvent<string | null>).detail);
  window.addEventListener(DRAG_HINT_EVENT, handler);
  return () => window.removeEventListener(DRAG_HINT_EVENT, handler);
}
